export default __webpack_public_path__ + "static/media/Regras-Incentivos-Programa-de-Excelência-FY25.6e862114.pdf";